import { render } from "./Footer.vue?vue&type=template&id=1d59bca2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1d59bca2&scoped=true&lang=css"

import exportComponent from "D:\\网页文件\\新闻网专题\\2023ZT\\Fzsp\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d59bca2"]])

export default __exports__